import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogTrigger,
} from "@/components/ui/dialog";

export const ChangePasswordDialog = () => {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) { toast.error("New password must be at least 8 characters."); return; }
    if (next !== confirm) { toast.error("New passwords do not match."); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated. Other sessions were signed out.");
      setOpen(false); setCurrent(""); setNext(""); setConfirm("");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Could not change password.");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" className="rounded-xl font-heading font-bold" data-testid="change-password-btn">
          <Lock className="w-4 h-4 mr-1" /> Change password
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading font-extrabold">Change password</DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2">
          <div>
            <Label htmlFor="cur" className="font-heading font-bold text-slate-800">Current password</Label>
            <Input id="cur" type="password" value={current} onChange={(e) => setCurrent(e.target.value)}
              className="mt-1.5 rounded-xl" data-testid="cp-current-input" />
          </div>
          <div>
            <Label htmlFor="new" className="font-heading font-bold text-slate-800">New password</Label>
            <Input id="new" type="password" value={next} onChange={(e) => setNext(e.target.value)}
              placeholder="At least 8 characters" className="mt-1.5 rounded-xl" data-testid="cp-new-input" />
          </div>
          <div>
            <Label htmlFor="cf" className="font-heading font-bold text-slate-800">Confirm new password</Label>
            <Input id="cf" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
              className="mt-1.5 rounded-xl" data-testid="cp-confirm-input" />
          </div>
          <DialogFooter>
            <Button type="submit" disabled={busy} data-testid="cp-submit-btn"
              className="rounded-xl font-heading font-bold w-full">
              {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : null} Update password
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
